import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Six-petal asterisk — a typographic dingbat. Rotates slowly and forever,
 *  with a gentle scale breath so the petals don't read as a solid wheel.
 *  Used as a punctuation mark between content blocks (a "fleuron"). */
export function IcnAsterisk(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const reduced = useReducedMotion();

  // Six lines from the center outward, evenly spaced.
  const arms = Array.from({ length: 6 }, (_, i) => i * 60);

  return (
    <Svg {...rest} iconName="asterisk" data-on={active ? 'true' : 'false'}>
      <g
        style={{
          transformOrigin: '8px 8px',
        }}
      >
        {arms.map((angle, i) => (
          <line
            key={i}
            x1="8"
            y1="8"
            x2="8"
            y2="2.5"
            transform={`rotate(${String(angle)} 8 8)`}
          />
        ))}
        <circle cx="8" cy="8" r="0.7" fill="currentColor" stroke="none" />
        {!reduced && active && (
          <>
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 8 8"
              to="360 8 8"
              dur="14s"
              repeatCount="indefinite"
            />
          </>
        )}
      </g>
    </Svg>
  );
}
